import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Spinner } from '@chakra-ui/react';
import { getTrackPathPrefix } from '@src/components/sco/Education/ContentTrackContext';
import { ContentTrackDashboard } from '@src/components/sco/Education/ContentTrackDetail/ContentTrackDashboard';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { EducationErrorState } from '@src/components/sco/Education/EducationErrorState';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
import React from 'react';
type ContentTrackDetailProps = {
  contentTrackSlug: string;
};
export const ContentTrackDetail = props => {
  const $ = _c(22);
  const educationContext = useEducationContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ContentTrackDetail.queries.contentTrack();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.contentTrackSlug) {
    t1 = {
      variables: {
        contentTrackSlug: props.contentTrackSlug
      }
    };
    $[1] = props.contentTrackSlug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const query = useQuery(t0, t1);
  let t2;
  if ($[3] !== educationContext || $[4] !== query.data?.contentTrack) {
    t2 = () => {
      educationContext.setActiveContentItem(query.data?.contentTrack);
      educationContext.setBreadcrumbs([{
        title: "Courses",
        href: "/courses"
      }, {
        title: query.data?.contentTrack?.title || "...",
        href: `/${getTrackPathPrefix(query.data?.contentTrack)}/${query.data?.contentTrack?.slug}`
      }]);
    };
    $[3] = educationContext;
    $[4] = query.data?.contentTrack;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = query.data?.contentTrack?.slug;
  let t4;
  if ($[6] !== t3) {
    t4 = [t3];
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useUniversalEffect(t2, t4);
  let t5;
  if ($[8] !== query.loading) {
    t5 = query.loading && <Center padding={10}><Spinner /></Center>;
    $[8] = query.loading;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== query.error) {
    t6 = query.error && <Box>{"Error: "}{query.error?.toString()}</Box>;
    $[10] = query.error;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== query.data?.contentTrack || $[13] !== query.loading) {
    t7 = !query.loading && !query.data?.contentTrack && <EducationErrorState ctaHref="/courses" ctaLabel="Explore All Courses" headingText="Course not found." />;
    $[12] = query.data?.contentTrack;
    $[13] = query.loading;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== query.data?.contentTrack) {
    t8 = query.data?.contentTrack && <ContentTrackDashboard contentTrack={query.data?.contentTrack} />;
    $[15] = query.data?.contentTrack;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <Box>{t5}{t6}{t7}{t8}</Box>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};
ContentTrackDetail.queries = {
  contentTrack: () => gql`
    query ($contentTrackSlug: String) {
      contentTrack(where: { slug: $contentTrackSlug }) {
        id
        slug
        title
        type
        ${ContentTrackDashboard.fragments.ContentTrack()}
      }
    }
  `
};